import Sentry from "@similarweb/sentry-logger";

import type { BenchmarkDataType } from "app/pages/benchmark-tracker/types/api.types";
import { ResponseError, type IFetchService } from "app/services/fetchService";
import { RESOURCE_NOT_FOUND_TYPE } from "app/services/fetchService/defaults";

import { BENCHMARK_USER_API } from "./constants";

type BenchmarkApiServiceEntity = {
    getBenchmarkById(benchmarkId: string): Promise<BenchmarkDataType | null>;
};

export const benchmarkApiService = (fetchService: IFetchService): BenchmarkApiServiceEntity => ({
    getBenchmarkById: async (benchmarkId: string): Promise<BenchmarkDataType | null> => {
        try {
            return await fetchService.get(`${BENCHMARK_USER_API}/${benchmarkId}`);
        } catch (error) {
            const isNotFound = error instanceof ResponseError && error?.problem?.type === RESOURCE_NOT_FOUND_TYPE;

            Sentry.errorTracker({
                e: error,
                message: "Benchmarks - error when fetching benchmark by id",
                level: isNotFound ? "warning" : "error",
                params: { extra: { benchmarkId } },
            });
            return null;
        }
    },
});
